import React from 'react';
import ButtonUI from './ButtonUI';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const FormButtonPanelUI = ({ onCancelClick, disabled, onSaveClick, saveDisabled }) => {
  const theme = useTheme();
  const ui = theme.palette.ui;

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        width: '100%',
        zIndex: 10,
        mt: 'auto',
        alignSelf: 'stretch',
        flexShrink: 0,
        background: theme.palette.background?.paper || '#fff',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 3,
          justifyContent: 'center',
          py: 1,
        }}
      >
        <ButtonUI
          text="Rögzítés"
          className="flex gap-2 items-center"
          style={{ background: ui.addButton }}
          type={'submit'}
          disabled={disabled}
        >
          Rögzítés
        </ButtonUI>
        {onSaveClick && (
          <ButtonUI
            text="Tervezet"
            className="bg-dark-primary flex items-center gap-2"
            type="button"
            onClick={onSaveClick}
            disabled={disabled || saveDisabled}
          ></ButtonUI>
        )}
        {onCancelClick && (
          <ButtonUI
            text="Mégse"
            className="flex items-center gap-2"
            style={{ background: ui.primaryButton }}
            type="button"
            onClick={onCancelClick}
            disabled={disabled}
          >
            Mégse
          </ButtonUI>
        )}
      </Box>
    </Box>
  );
};

export default FormButtonPanelUI;
